import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPicture = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.186 3.5c-.37 0-.672.3-.672.673v7.864q.678-.076 1.361-.076a11.2 11.2 0 0 1 8.51 3.635 12 12 0 0 1 4.296-.788c.951 0 1.897.114 2.819.339V4.173a.673.673 0 0 0-.672-.673zM20.5 16.698c-.916-.26-1.865-.39-2.819-.39h-.002a10.5 10.5 0 0 0-3.308.53 11.2 11.2 0 0 1 1.64 3.662h3.817c.37 0 .672-.3.672-.673zM15.42 22h4.408c1.2 0 2.172-.974 2.172-2.173V4.173C22 2.973 21.028 2 19.828 2H4.186c-1.2 0-2.172.973-2.172 2.173v8.591a.8.8 0 0 0 0 .288v6.774c0 1.2.972 2.174 2.172 2.174H15.42m-.962-1.5A9.71 9.71 0 0 0 4.9 13.461h-.02q-.685 0-1.366.087v6.279c0 .372.302.673.672.673zm.734-13.442a1.74 1.74 0 1 0 .002 3.479 1.74 1.74 0 0 0-.002-3.48m-3.238 1.74a3.24 3.24 0 1 1 3.238 3.24 3.24 3.24 0 0 1-3.238-3.24"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPicture;
